import type {
  AvailableMap,
  ScheduleOccurrence,
  ScheduleRoute,
  ScheduleRoutine,
} from 'app/modules/machine-inventory/ScheduleClient';
import type { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import type { Optional } from 'lib/types/Optional';
import type {
  AssociateDevicesToMapResponse,
  CleaningScheduleV2,
  Map,
  MapGroup,
  QueryCleaningScheduleOccurrencesArgs,
} from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

export const selectRobotScheduleRoutines = (state: IState): Optional<ScheduleRoutine[]> =>
  state.modules['machine-inventory']['robot-schedule'].routines.data;

export const selectRobotScheduleRoutinesIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].routines.isLoading;

export const selectRobotScheduleRoutinesError = (state: IState): Optional<unknown> =>
  state.modules['machine-inventory']['robot-schedule'].routines.error;

export const selectRobotScheduleRoutes = (state: IState): Optional<ScheduleRoute[]> =>
  state.modules['machine-inventory']['robot-schedule'].routes.data;

export const selectRobotScheduleRoutesIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].routes.isLoading;

export const selectRobotScheduleRoutesError = (state: IState): Optional<unknown> =>
  state.modules['machine-inventory']['robot-schedule'].routes.error;

export const selectScheduleMaps = (state: IState): Optional<Map[]> =>
  state.modules['machine-inventory']['robot-schedule'].maps.data;

export const selectScheduleMapsIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].maps.isLoading;

export const selectRobotScheduleOccurrences = (state: IState): Optional<ScheduleOccurrence[]> =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.data;

export const selectRobotScheduleOccurrencesIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.isLoading;

export const selectRobotScheduleOccurrencesIsRefreshing = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.isRefreshing;

export const selectRobotScheduleOccurrencesLastSyncedAt = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.lastSyncedAt;

export const selectRobotScheduleOccurrencesError = (state: IState): Optional<unknown> =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.error;

export const selectRobotScheduleOccurrencesLastRequest = (
  state: IState
): Optional<QueryCleaningScheduleOccurrencesArgs> =>
  state.modules['machine-inventory']['robot-schedule'].occurrences.lastRequest;

export const selectCreateScheduleData = (state: IState): Optional<CleaningScheduleV2> =>
  state.modules['machine-inventory']['robot-schedule'].create.data;

export const selectCreateScheduleIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].create.isLoading;

export const selectUpdateScheduleData = (state: IState): Optional<CleaningScheduleV2> =>
  state.modules['machine-inventory']['robot-schedule'].update.data;

export const selectUpdateScheduleIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].update.isLoading;

export const selectDeleteScheduleData = (state: IState): Optional<CleaningScheduleV2> =>
  state.modules['machine-inventory']['robot-schedule'].delete.data;

export const selectDeleteScheduleIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].delete.isLoading;

export const selectAvailableMaps = (state: IState): Optional<AvailableMap[]> =>
  state.modules['machine-inventory']['robot-schedule'].availableMaps.data;

export const selectAvailableMapsIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].availableMaps.isLoading;

export const selectAvailableMapGroups = (state: IState): Optional<MapGroup[]> =>
  state.modules['machine-inventory']['robot-schedule'].availableMapGroups.data;

export const selectAvailableMapGroupsIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].availableMapGroups.isLoading;

export const selectAssociateDevicesToMapData = (state: IState): Optional<AssociateDevicesToMapResponse> =>
  state.modules['machine-inventory']['robot-schedule'].associateDevicesToMap.data;

export const selectAssociateDevicesToMapIsLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-schedule'].associateDevicesToMap.isLoading;

export const selectAssociateDevicesToMapError = (state: IState): Optional<unknown> =>
  state.modules['machine-inventory']['robot-schedule'].associateDevicesToMap.error;
